import { CustomizableFilterColumn } from "../../components/ColumnsCustomizeModal/CustomizableColumn"
import { Pool } from "./RandomsModel/PoolData"

export const COLUMNS = [
  "PoolName",
  "Code",
  "SelectionInterval",
  "LastSelection",
  "DrugSampleSize",
  "AlcoholSampleSize",
] as const

export type ColumnName = (typeof COLUMNS)[number]
export type ColumnFilters = Record<ColumnName, string[]>
export type Column = CustomizableFilterColumn<Extract<keyof Pool, ColumnName>, keyof ColumnFilters>

export const DEFAULT_COLUMNS: Column[] = [
  { name: "PoolName", label: "Name", filter: "PoolName", visible: true },
  { name: "Code", label: "Code", visible: true },
  {
    name: "SelectionInterval",
    label: "Selection Interval",
    filter: "SelectionInterval",
    visible: true,
  },
  {
    name: "LastSelection",
    label: "Last Selection",
    visible: true,
  },
  {
    name: "DrugSampleSize",
    label: "Drug",
    visible: true,
  },
  {
    name: "AlcoholSampleSize",
    label: "Alcohol",
    visible: true,
  },
]
